import { ThemeIcon } from '@mantine/core';
import { IconDoor } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { LinkOrigin } from 'src/Services/API/EntityLinks.api';

import styles from './LinkedRoomItem.module.scss';
import { Props } from './LinkedRoomItem.types';

const LinkedRoomItem = ({ item, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} onClick={onClick}>
      <ThemeIcon variant="light" color="teal" size="lg" radius="md">
        <IconDoor size={18} />
      </ThemeIcon>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {item.subtitle && <span className={styles.subtitle}>{item.subtitle}</span>}
      </div>
      {item.linkOrigin === LinkOrigin.Business && (
        <span className={styles.origin}>
          {t('entityLinks.automaticLink', 'relié automatiquement')}
        </span>
      )}
    </div>
  );
};

export default LinkedRoomItem;
